import { Message, UIMessage, SSEMessage } from '../../../types/chat';

export const isUIMessage = (message: Message): message is UIMessage => {
    return message.type === 'ui';
};

export const isValidSSEMessage = (data: unknown): data is SSEMessage => {
    if (typeof data !== 'object' || data === null) {
        return false;
    }

    const msg = data as Partial<SSEMessage>;
    
    if (msg.type === 'text') {
        return typeof msg.content === 'string';
    }
    
    if (msg.type === 'ui') {
        return typeof msg.ui_type === 'string' && 
               typeof msg.ui_data === 'object' && 
               msg.ui_data !== null;
    }

    return false;
};

export const isValidThreadId = (threadId: unknown): threadId is string => {
    return typeof threadId === 'string' && threadId.length > 0;
};

export const isValidMessageText = (text: string): boolean => {
    return text.trim().length > 0;
}; 